var tasks = [];
var isRunningTask = false;

function doNextTask() {
    if (isRunningTask) return;

    var task = tasks.shift();

    if (task === undefined) return;

    isRunningTask = true;

    task.fn()
    .then(function() {
        task.resolve();
    })
    .catch(function(error) {
        task.reject(error);
    })
    .finally(function() {
        isRunningTask = false;
        setTimeout(doNextTask, 1);
    });
}

function execute(fn) {
    return new Promise(function (resolve, reject) {
        tasks.push({ resolve: resolve, reject: reject, fn: fn });
        doNextTask();
    });
}

module.exports = {
    execute: execute,
};
